import React, { useEffect } from 'react';
import { ContactSection } from '../components/ContactSection';
export function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-250">
      <ContactSection data-id="element-251" />
    </div>;
}